export default __webpack_public_path__ + "scene01a635af.jpg";